export const SET_LOCATIONS = 'SET_LOCATIONS';

// initial state
const state = {
    list: {},
    active: {}
}

// getters
const getters = {
    locations: state => state.list,
    location: state => state.active
}

// actions
const actions = {

    getLocations: ({commit, state}, payload) => {
        axios.get(laroute.route('api.locations.index'))
            .then((response) => {
                commit(SET_LOCATIONS, {
                    types: response.data.data
                });
            })
    }
}

// mutations
const mutations = {
    SET_LOCATIONS: (state, payload) => {
        state.list = Object.assign({}, state.list, payload.types);
    }
}

export default {
  state,
  getters,
  actions,
  mutations
}
